export default __webpack_public_path__ + "static/media/personal.7bc631c7.svg";